<template>
  <div>
    <div v-if="schedule && schedule.rrule != null">
      <span class="text-h6">Recurring Schedule </span>
      {{ schedule | scheduleText }}
    </div>
    <v-divider class="my-2" />
    <div class="text-h6 my-5">Choose an option below</div>
    <v-radio-group v-model="option">
      <v-radio
        value="cancel"
        :label="`Cancel Class on ${cancelationDate} ${formatTime(
          schedule.startTime
        )} - ${formatTime(schedule.endTime)}`"
      ></v-radio>
      <v-radio
        :label="`Reschedule class on ${cancelationDate}`"
        value="reschedule"
      ></v-radio>
    </v-radio-group>

    <v-form class="ma-0 mx-lg-5" v-if="option == 'reschedule'">
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1">New Schedule</div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="date"
            label="Start Date*"
            prepend-icon="mdi-calendar"
            type="date"
            clearable
            :rules="[rules.required]"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          <v-text-field
            v-model="startTime"
            label="Start Time*"
            prepend-icon="mdi-clock-time-four-outline"
            type="time"
            :rules="[rules.required]"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          <v-text-field
            v-model="endTime"
            label="End Time*"
            prepend-icon="mdi-clock-time-four-outline"
            type="time"
            :rules="[
              rules.required,
              rules.timeRange(this.startTime, this.endTime),
            ]"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-textarea
            v-model="remark"
            :auto-grow="true"
            rows="1"
            label="Remark"
          />
        </v-col>
        <v-col cols="12" lg="12">
            <v-checkbox class="pa-0 ma-0" :hide-details="true" v-model="syncGoogleCalendarEvent" label="Sync Google Calendar on new schedule" />
        </v-col>
        <v-col cols="12" lg="12">
            <v-checkbox class="pa-0 ma-0" :hide-details="true" v-model="retainTeacher" label="Retain the same teacher for new schedule" />
        </v-col>
      </v-row>
    </v-form>

    <div class="text-center ma-5">
      <v-btn :disabled="isAppLoading" @click="save" color="primary"> Save </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { rules } from "@/store/util/rules.js";

export default {
  props: {
    courseSchedule: {
      type: Object,
      required: true,
    },
    scheduleDate: {
      type: [String, Date],
      required: true,
    },
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
    schedule() {
      return this.courseSchedule;
    },
    cancelationDate() {
      return moment(this.scheduleDate).format("ddd, MMM DD YYYY");
    },
  },
  data: () => {
    return {
      option: "cancel",
      startTime: null,
      endTime: null,
      date: null,
      remark: null,
      syncGoogleCalendarEvent: true,
      retainTeacher: true,
      rules,
    };
  },
  mounted() {
    if (this.schedule && this.schedule.id) {
      this.startTime = this.schedule.startTime;
      this.endTime = this.schedule.endTime;
      this.date = moment(this.scheduleDate).add(1, "days").format("YYYY-MM-DD");

      this.remark = `Makeup session for ${this.formatDate(this.date)}`;
    }
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    save() {
      if (this.option == "cancel") {
        this.cancelClass();
      } else {
        this.rescheduleClass();
      }
    },
    rescheduleClass() {
      const data = {
        courseScheduleId: this.schedule.id,
        date: moment(this.scheduleDate).format("YYYY-MM-DD"),
        newDate: this.date,
        newStartTime: this.startTime,
        newEndTime: this.endTime,
        remark: this.remark,
        timezoneOffset: new Date().getTimezoneOffset(),
        syncGoogleCalendarEvent: this.syncGoogleCalendarEvent,
        retainTeacher: this.retainTeacher,
      };
      this.$axios
        .post("/course-schedule/reschedule-class", data)
        .then(() => {
          this.addSuccessMessage(
            'Class canceled and rescheduled'
          );

          this.$emit("canceledClass", {
            schedule: this.schedule,
            scheduleDate: this.scheduleDate,
          });
        })
        .catch(() => {
          this.addErrorMessage(
            "Oops! something went wrong, please try again later."
          );
        });
    },
    cancelClass() {
      const data = {
        courseScheduleId: this.schedule.id,
        date: moment(this.scheduleDate).format("YYYY-MM-DD"),
      };
      this.$axios
        .post("/course-schedule/cancel-class", data)
        .then(() => {
          this.addSuccessMessage('Class canceled');

          this.$emit("canceledClass", {
            schedule: this.schedule,
            scheduleDate: this.scheduleDate,
          });
        })
        .catch(() => {
          this.addErrorMessage(
            "Oops! something went wrong, please try again later."
          );
        });
    },
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    },
    formatTime(value) {
      return moment(value, "HH:mm").format("h:mm a");
    },
  },
};
</script>

<style>
</style>